export const CASE_STUDIES = [
  {
    client: 'Content Creator',
    result: 'Ads finally profitable',
    detail:
      'Before us their spend was simply burning. We rebuilt the account structure and creative testing framework — the ads started working, and stayed working.',
    metric: 'From burning cash to profitable',
  },
  {
    client: 'Mid-Sized Company',
    result: '1M+ views in 45 days',
    detail:
      'A single creative system, versioned across placements and audiences, took them past one million views inside forty-five days.',
    metric: 'From zero to viral in about a month',
  },
  {
    client: 'Small Business',
    result: 'Daily inbound leads',
    detail:
      'They relied entirely on referrals. We installed a paid acquisition engine — leads now arrive every day, independent of who they know.',
    metric: 'Leads every single day',
  },
  {
    client: 'Startup',
    result: '10 high-ticket closes in 3 weeks',
    detail:
      'Offer positioning, qualification and Meta targeting rebuilt together. Ten high-ticket deals closed within three weeks of launch.',
    metric: 'Unfair advantage in 3 weeks',
  },
  {
    client: 'Medium Business',
    result: '5x conversion rate',
    detail:
      'Same traffic, materially more value. We reengineered the funnel and message match to multiply conversion five times over.',
    metric: '5x conversion explosion',
  },
  {
    client: 'Corporate',
    result: '$13M+ saved in 12 months',
    detail:
      'Digital transformation, online reengineering and disciplined paid media saved over thirteen million dollars across a single financial year.',
    metric: 'Millions in bottom-line savings',
  },
];

export const SYSTEM_STEPS = [
  {
    step: '01',
    title: 'Spend Forensics',
    body:
      'We audit every campaign, ad set and creative to locate exactly where money is leaving without returning — wasted overlap, fatigued creative, broken attribution.',
  },
  {
    step: '02',
    title: 'Offer & Message Match',
    body:
      'Your offer is rewritten against what the market actually responds to, so the click, the landing page and the promise finally say the same thing.',
  },
  {
    step: '03',
    title: 'Creative Engine',
    body:
      'A production system, not one-off ads: hooks, angles and formats produced and tested weekly so winners are found deliberately rather than by luck.',
  },
  {
    step: '04',
    title: 'Structured Scaling',
    body:
      'Budget is moved only against verified signal. We scale in controlled increments that protect CPA instead of collapsing it.',
  },
  {
    step: '05',
    title: 'Retention & Compounding',
    body:
      'Email, retargeting and lifetime value work compound each acquired customer, which is what makes $100k/month sustainable rather than a spike.',
  },
];

export const FAQS = [
  {
    q: 'What exactly is the Free Meta Ads Breakdown?',
    a: 'A senior strategist reviews your current spend, structure and creative approach and returns a written breakdown of where your money is bleeding, what to fix first, and the realistic path from your current revenue to $100k/month. There is no obligation and no charge.',
  },
  {
    q: 'What monthly ad spend do you work with?',
    a: 'We work with brands spending from roughly $3,000 per month upward. Below that, we will tell you honestly what to fix yourself before paid media is worth scaling.',
  },
  {
    q: 'How quickly will we see results?',
    a: 'Structural waste is usually removed within the first two weeks. Meaningful performance change typically appears inside the first 30 to 45 days, with compounding gains thereafter.',
  },
  {
    q: 'Do you handle creative, or do we?',
    a: 'We handle it. Our production studio builds the hooks, edits and formats the algorithm needs, and versions them per placement and market. You are never left waiting on assets.',
  },
  {
    q: 'What if we have already been burned by an agency?',
    a: 'Most of our clients have. That is precisely why we begin with forensics rather than promises — you see exactly what was wrong in the account before any money changes hands.',
  },
  {
    q: 'Is this only for e-commerce brands?',
    a: 'No. We run acquisition for e-commerce, high-ticket services, B2B lead generation and corporate digital transformation programmes across UK, EU, US and African markets.',
  },
];